// src/components/filter.
import { OrderStatus } from "enum/OrderStatus";
import { Order } from "models/Order";
import React, { useEffect, useMemo, useState } from "react";
import { displayOrderCity } from "helpers/orderAddress";
import { Row, Col, CardBody, Card } from "reactstrap";
//import components
import { OrderDuration } from "enum/OrderDuration";
import { format } from "date-fns";
import Breadcrumb from "components/Common/Breadcrumb";
import { AdminService } from "services/AdminService";
import AdminTableContainer from "../AdminTableContainer";
import { useDispachCount } from "context/OrderCountProvider";
import { Puff } from "react-loader-spinner";
import { DispatchType } from "enum/DispatchType";

const AdminPickupOrders: React.FC = () => {
  const [pickupOrders, setPickupOrders] = useState([] as Order[]);
  const [isModified, setIsModified] = useState<boolean>(false);
  const [isloading, setIsloading] = useState<boolean>(true);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTimeRemaining = (diffMs: number) => {
    const absDiffMs = Math.abs(diffMs);
    const hours = Math.floor(absDiffMs / (1000 * 60 * 60));
    const minutes = Math.floor((absDiffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((absDiffMs % (1000 * 60)) / 1000);

    const formatTwoDigits = (num: number) => num.toString().padStart(2, '0');

    if (diffMs < 0) {
      return `-${formatTwoDigits(hours)}:${formatTwoDigits(minutes)}:${formatTwoDigits(seconds)}`;
    } else {
      return `${formatTwoDigits(hours)}:${formatTwoDigits(minutes)}:${formatTwoDigits(seconds)}`;
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Order Id",
        accessor: "uniqueId",
        Cell: ({ value }: any) => {
          return <div className="link-primary">{value}</div>;
        },
      },
      {
        Header: "Company Name",
        accessor: "companyName",
      },
      {
        Header: "Date",
        accessor: "deliveryTime",
        Cell: ({ value }: any) => {
          return format(new Date(value), "dd.MM.yyyy");
        },
      },
      {
        Header: "Pickup",
        accessor: "pickUpAddress.city",
        Cell: ({ row }: any) => {
          return displayOrderCity(row.original.pickUpAddress);
        },
      },
      {
        Header: "PPC",
        accessor: "pickUpAddress.postalCode",
        Cell: ({ value }) => <div style={{ width: 80 }}>{value}</div>,
      },
      {
        Header: "Delivery",
        accessor: "deliveryAddress.city",
        Cell: ({ row }: any) => {
          return displayOrderCity(row.original.deliveryAddress);
        },
      },
      {
        Header: "DPC",
        accessor: "deliveryAddress.postalCode",
        Cell: ({ value }) => <div style={{ width: 80 }}>{value}</div>,
      },
      {
        Header: "Driver",
        accessor: "driverUser.name",
      },
      {
        Header: "Weight (lbs)",
        accessor: "totalWeight",
        Cell: props => {
          return props.value.replace(/ pounds/gi, "");
        },
      },
      {
        Header: "Vehicle type",
        accessor: "vehicleType",
      },
      {
        Header: "Price",
        accessor: "subTotal",
        Cell: ({ value }) => `$${value.toFixed(2)}`,
      },
      {
        Header: "Order time",
        accessor: "packageReadyTime",
        Cell: ({ row }: any) => {
          return format(new Date(row.original.packageReadyTime), "hh:mma") + " to " + format(new Date(row.original.deliveryTime), "hh:mma");
        },
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        Cell: props => {
          return props.value.replace(/_/g, " ").replace(/\b\w/g, (char: string) => char.toUpperCase());
        },
      },
      {
        Header: "Remaining Time",
        Cell: ({ row }: any) => {
          const deliveryTime = new Date(row.original.deliveryTime);
          const currentTime = new Date();

          const diffMs = deliveryTime.getTime() - currentTime.getTime();

          let timeColor = "#28a745";
          let backgroundColor = 'transparent';
          let statusText = formatTimeRemaining(diffMs);

          if (diffMs < 0) {
            timeColor = "#dc3545";
            backgroundColor = '#ffe6e6';
          } else if (diffMs < 30 * 60 * 1000) {
            timeColor = "#dc3545";
          } else if (diffMs < 60 * 60 * 1000) {
            timeColor = "#ffc107";
          }

          return (
            <div
              style={{
                color: timeColor,
                fontWeight: 'bold',
                fontSize: '14px',
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: backgroundColor,
                textAlign: 'center',
                minWidth: '100px',
                fontFamily: 'monospace'
              }}
            >
              {statusText}
            </div>
          );
        },
      }
    ],
    [currentTime]
  );

  const [LIMIT_P_C, setLIMIT_P_C] = useState<number>(10);
  const [isOffset_p_c, setOffset_p_c] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(1);

  const data = {
    duration: OrderDuration.CURRENT,
    uniqueId: "",
  };

  const [dispachCount, setDispachCount] = useDispachCount();

  const statuscount = async () => {
    await AdminService.getalldispachcount().then(res => {
      if (res.success) {
        setDispachCount(res.data);
      } else {
      }
    });
  };

  useEffect(() => {
    setIsloading(true);
    AdminService.getOrdersByStatus(data, OrderStatus.PICKED, LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        setPickupOrders(res.data.orderList);
        setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
      } else {
      }

      setIsloading(false);
    });
    statuscount();
  }, [isModified]);

  const getChangedStatusDataHandler = () => {
    AdminService.getOrdersByStatus(data, OrderStatus.PICKED, LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        setPickupOrders(res.data.orderList);
        setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
      } else {
      }
    });
  };

  const SeeMore = (page: any) => {
    setOffset_p_c(page.selected + 1);
    AdminService.getOrdersByStatus(data, OrderStatus.PICKED, LIMIT_P_C, page.selected + 1).then(res => {
      if (res.success) {
        setPickupOrders(res.data.orderList);
        setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
      }
    });
  };

  const handleColumnChange = (selectedOption: any) => {
    setLIMIT_P_C(selectedOption.value);
    AdminService.getOrdersByStatus(data, OrderStatus.PICKED, selectedOption.value, 1).then(res => {
      if (res.success) {
        setPickupOrders(res.data.orderList);
        setPageCount(Math.ceil(res.data.count / selectedOption.value));
      }
    });
  };

  const searchTable = (serchText: string) => {
    const searchdata = {
      status: OrderStatus.PICKED,
      uniqueId: "",
      dispatchType: DispatchType.PICK_UP_ORDERS,
      searchableString: serchText,
    };

    AdminService.getOrderdispachsBySearch(searchdata, LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        setPickupOrders(res.data.orderList);
        setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
      }
    });
  };

  //meta title
  document.title = "Pickup Orders | Zulu Courier";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb title="Dispatch" breadcrumbItem="Pickup Orders" />
        <Col lg={12}>
          <Card>
            <CardBody>
              {isloading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "500px" }}>
                  <Puff color="#FFD0B8" height={50} width={50} />
                </div>
              ) : (
                <>
                  {pickupOrders.length > 0 ? (
                    <AdminTableContainer
                      columns={columns}
                      data={pickupOrders}
                      pagelimit={pageCount}
                      handlePageChange={SeeMore}
                      handleSearch={searchTable}
                      handleColumnChange={handleColumnChange}
                      selectedColumns={LIMIT_P_C}
                      showColumnChange={true}
                      customPageSize={50}
                      className="custom-header-css"
                      isJobListGlobalFilter={undefined}
                      isChangeDateList={true}
                      isChangeDriverList={false}
                      isChangeMultipleStatus={true}
                      isModified={isModified}
                      setIsModified={setIsModified}
                      isPDFGenerate={true}
                      ispopup={true}
                      isAddressBook={false}
                      hancleDeleteRecords={undefined}
                      handleSelect={undefined}
                      selectedID={undefined}
                      getChangedStatusData={getChangedStatusDataHandler}
                      currentStatus={OrderStatus.PICKED}
                    />
                  ) : (
                    <Row className="justify-content-md-center justify-content-center align-items-center">
                      <Col className="col-md-auto">
                        <div>No Pickup Orders</div>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </div>
    </div>
  );
};

export default AdminPickupOrders;
